import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { BetslipModalMobileComponent } from './betslip-modal-mobile/betslip-modal-mobile.component';
import { TranslocoModule } from '@jsverse/transloco';
import { AccountService } from '@services/account.service';
import { LoginModalComponent } from '@app/authentication/login-modal/login-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';

@Component({
    selector: 'app-footer-mobile',
    templateUrl: './footer-mobile.component.html',
    styleUrls: ['./footer-mobile.component.scss'],
    imports: [CommonModule, BetslipModalMobileComponent, TranslocoModule, RouterModule],
})
export class FooterMobileComponent implements OnInit {
    user$ = this.accountService.userSubject.asObservable();
    @Input() isMyBets = false;

    private overlay = inject(Overlay);
    constructor(
        private router: Router,
        private accountService: AccountService,
        public dialog: MatDialog,
    ) {}

    ngOnInit(): void {}

    goToMyBets() {
        if (this.checkLogin()) {
            this.router.navigate(['/dashboard/ticket-check'], { queryParams: { tab: 'SPORTS' } });
        } else {
        }
    }

    checkLogin(): boolean {
        if (!this.accountService.isAuthenticated().value) {
            this.dialog.open(LoginModalComponent, {
                panelClass: 'full-screen-dialog',
                scrollStrategy: this.overlay.scrollStrategies.noop(),
            });
            return false;
        }
        return true;
    }
}
